module.exports = "<div id=\"content\">\n\t<h1 align=\"center\">Doh! Sorry, Homer ate the Page :(</h1>\n\t<div>\n\t\t<img class=\"centered\" src=\"https://s-media-cache-ak0.pinimg.com/236x/aa/33/1f/aa331f1a8ce02c2723a0bd4ad69465b4.jpg\">\n\t</div>\n\t<h1 align=\"center\" class=\"bottom-header\">404</h1>\n\t<h5 align=\"center\"><a href=\"/\">Home</a></h5>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/error/error.component.html
// module id = 873
// module chunks = 0